<main
  *ngIf="viewModel$ | async as vm"
  class="grid jobsv2-{{ colorScheme.colorScheme.value }}"
>
  <div class="job-column">
    <header>
      <div *ngIf="vm.showSkeleton; else headerDetails" class="header-skeleton">
        <p-skeleton width="19.38rem" height="2rem"></p-skeleton>
        <p-skeleton width="21.25rem " height="1.44rem"></p-skeleton>
        <p-skeleton
          width="4.81rem"
          height="0.88rem"
          styleClass="header-skeleton-badge"
        ></p-skeleton>
      </div>
      <ng-template #headerDetails>
        <app-job-header-details></app-job-header-details>
      </ng-template>
      <div class="header-actions">
        <p-skeleton
          *ngIf="vm.showSkeleton; else actionsButton"
          width="3rem"
          height="2.8rem"
          borderRadius="0.5rem"
        ></p-skeleton>
        <ng-template #actionsButton>
          <button
            *ngIf="vm.hasJob"
            pButton
            icon="pi pi-ellipsis-v"
            class="p-button-outlined p-button-rounded"
            (click)="toggleActionsMenu($event)"
            aria-label="Job actions"
          ></button>
          <p-menu
            #actionsMenu
            [model]="vm.jobMenuItems"
            [popup]="true"
            appendTo="body"
          ></p-menu>
        </ng-template>
      </div>
    </header>

    <div
      *ngIf="vm.editDisabledWarning?.type === 'above-zone'"
      class="p-message p-message-warn p-mb-2 edit-disabled-warning"
      role="alert"
    >
      <span class="p-message-icon pi pi-exclamation-triangle"></span>
      <div class="p-message-text">
        <span class="warning-with-action">
          <span>{{ vm.editDisabledWarning.text }}</span>
          <span class="warning-buttons">
            <button
              pButton
              type="button"
              class="p-button-warning p-button-outlined"
              icon="pi pi-download"
              label="Import"
              (click)="store.dispatch(jobToolActions.importJobButtonClicked())"
            ></button>
          </span>
        </span>
      </div>
    </div>

    <p-card styleClass="p-mb-3">
      <ng-template pTemplate="header">
        <div class="card-header">
          <div class="title-container">
            <h2>{{ vm.title }}</h2>
            <div
              class="edit-deselect-buttons"
              *ngIf="vm.showCustomerActionButtons"
            >
              <p-message
                *ngIf="!vm.customerEditable?.customerEditable"
                severity="warn"
                [text]="vm.customerEditable?.notEditableWarning"
                styleClass="existing-customer-warning"
              ></p-message>
              <button
                pButton
                *ngIf="vm.selectedCustomer"
                class="p-button-outlined p-button-sm deselect-btn discard-button"
                label="Clear Customer"
                icon="pi pi-times"
                [disabled]="vm.isCustomerModified"
                (click)="
                  $event.stopPropagation();
                  store.dispatch(customerActions.clearCustomerButtonClicked())
                "
              ></button>
              <button
                pButton
                type="button"
                class="p-button-outlined p-button-sm repeat-customer-btn"
                label="Repeat Customer"
                icon="pi pi-search"
                [disabled]="!vm.customerEditable?.customerEditable"
                (click)="
                  store.dispatch(
                    searchCustomersDialogActions.repeatCustomerButtonClicked()
                  )
                "
              ></button>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <ng-container [ngSwitch]="vm.step">
          <ng-container *ngSwitchCase="'customer'">
            <app-new-opportunity-customer></app-new-opportunity-customer>
          </ng-container>
          <ng-container *ngSwitchCase="'locations'">
            <app-new-opportunity-locations></app-new-opportunity-locations>
          </ng-container>
          <ng-container *ngSwitchCase="'inventory'">
            <app-new-opportunity-add-inventory></app-new-opportunity-add-inventory>
            <app-inventory-table></app-inventory-table>
          </ng-container>
          <ng-container *ngSwitchCase="'workorders'">
            <app-mr-calculator *ngIf="vm.showCalculator"></app-mr-calculator>
            <app-events-table></app-events-table>
          </ng-container>
        </ng-container>
        <app-step-navigation></app-step-navigation>
      </ng-template>
    </p-card>
  </div>

  <div class="job-column">
    <p-card>
      <app-stepper></app-stepper>
    </p-card>
    <app-new-opportunity-summary
      class="summary-section"
    ></app-new-opportunity-summary>
  </div>
</main>
<app-timeline-book-event></app-timeline-book-event>
